import { call, put } from "redux-saga/effects";
import { MLAPI } from "api";
import * as Actions from "UserAuthorized/actionTypes";
import SentLinkResponse from "contracts/responses/SentLinkResponse";
import _ from "lodash";

export function* getLinks() {
  const { response, error } = yield call(MLAPI.links.getLinks);

  if (response) {
    yield put({
      type: Actions.LINKS_GET_LINKS_SUCCESSFUL,
      payload: response.data.data
    });
  } else
    yield put({
      type: Actions.LINKS_GET_LINKS_ERROR,
      payload: error
    });
}
